import React, { useState } from "react";
import DataDisplay from "./DataDisplay";
import formTwoDigitArray from "../../util/formTwoDigitArray";
import { Link } from "react-router-dom";

function Memorize() {
  const [number, setNumber] = useState("");
  const [savednumber, setSavedNumber] = useState("");
  const [response, setresponse] = useState([]);

  const handleChange = (event) => {
    const value = event.target.value;
    if (!isNaN(value)) {
      if (value >= 0) setNumber(value);
    }
  };

  const handleSubmit = () => {
    let response = formTwoDigitArray(number);
    setresponse(response);
    setSavedNumber(number);
    setNumber("");
  };

  const handleClear = () => {
    setresponse([]);
  };

  return (
    <div className="h-screen flex flex-col justify-end m-2 bg-gray-800 p-5 font-mono">
      <DataDisplay dataArr={response} number={savednumber} />
      <div className="flex justify-center py-3">
        <Link className="text-white border rounded-md p-1 text-xs" to={"/all_data_list"} >All Data Table</Link>
        <Link className="text-white border rounded-md p-1 mx-1 text-xs" to={"/digit_to_letter"} >0 - 9 Data</Link>
      </div>
      <div className="flex justify-center items-center">
        {response.length > 0 ? (
          <button
            className="w-1/2 bg-red-400 text-white text-lg py-2 rounded-xl ml-2 focus:outline-none"
            onClick={handleClear}
          >
            Clear 😵
          </button>
        ) : (
          <>

            <input
              type="number"
              className="w-3/4 md:w-40 text-lg text-center rounded-xl bg-gray-200 py-2 focus:outline-none"
              placeholder="Enter a number"
              value={number}
              onChange={handleChange}
            />
            <button
              className="w-1/4 bg-yellow-200 text-gray-700 text-lg py-2 rounded-xl ml-2 focus:outline-none"
              onClick={handleSubmit}
            >
              Submit
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default Memorize;
